import * as Constant from './Constant';
import axios from 'axios';

export const TcbGetQR = (data, token) => {
  return axios.get(`${Constant.DOMAIN_CLIENT}/tcbQrCode/getQR`, {
    params: data,
    headers: { Authorization: token },
  });
};

export const TcbCheckPayment = (data, token) => {
  return axios.get(`${Constant.DOMAIN_CLIENT}/tcbQrCode/isPaymentSuccess`, {
    params: data,
    headers: { Authorization: token },
  });
};
